import { render, staticRenderFns } from "./CommaLabel.vue?vue&type=template&id=1f864538&scoped=true"
import script from "./CommaLabel.vue?vue&type=script&lang=js"
export * from "./CommaLabel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f864538",
  null
  
)

export default component.exports